import { retryUnlessForbidden } from "@sidegigllc/api";
import { customFetch } from "@sidegigllc/api/client";
import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import type { QueryOptions } from "api/queries/types";

// `customFetch` revives ISO-datetime strings to `Date` and decimal strings to
// `number`, so change values arrive already coerced rather than as bare strings.
export type ShiftBreakHistoryValue = string | number | Date | null;

export type ShiftBreakHistoryChange = {
  field: string;
  old_value: ShiftBreakHistoryValue;
  new_value: ShiftBreakHistoryValue;
};

export type ShiftBreakHistoryRevision = {
  user: string;
  timestamp: Date;
  changes: Array<ShiftBreakHistoryChange>;
};

// Hand-rolled because this endpoint is absent from the generated client, so there is no typed hook to reuse.
/** Read-only edit history for a single shift break, newest revision first. Non-admins get a 403. */
export const useShiftBreakHistory = (
  id: string | undefined,
  options?: QueryOptions<Array<ShiftBreakHistoryRevision>>,
) =>
  useQuery(
    queryOptions({
      queryKey: ["SHIFT_BREAK_HISTORY", id],
      queryFn:
        id == null
          ? skipToken
          : () =>
              customFetch<Array<ShiftBreakHistoryRevision>>(`/api/timesheets/shift-breaks/${id}/history/`, {
                method: "GET",
              }),
      retry: retryUnlessForbidden,
      ...options,
    }),
  );
